module.exports = __webpack_public_path__ + "media/23_BL.7943e51d.mp3";